import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const ax = axios.create({ baseURL: API, withCredentials: true });

export const rosterApi = {
  list: (params) => ax.get('/api/clinic-ops/roster', { params }).then((r) => r.data),
  create: (body) => ax.post('/api/clinic-ops/roster', body).then((r) => r.data),
  update: (id, body) => ax.patch(`/api/clinic-ops/roster/${id}`, body).then((r) => r.data),
  remove: (id) => ax.delete(`/api/clinic-ops/roster/${id}`).then((r) => r.data),
  recurring: (body) => ax.post('/api/clinic-ops/roster/recurring', body).then((r) => r.data),
  publish: (body) => ax.post('/api/clinic-ops/roster/publish', body).then((r) => r.data),
  staff: (params = {}) => ax.get('/api/clinic-ops/staff', { params }).then((r) => r.data),
  doctors: () => ax.get('/api/clinic-ops/doctors').then((r) => r.data),
};
